import Lottie from 'lottie-react';

import animation from './animation.json';

import { LoadingProps } from './types';

import * as S from './styles';

const Loading: React.FC<LoadingProps> = ({ isLoading }) => {
  return isLoading ? (
    <S.Div data-testid="loading">
      <Lottie animationData={animation} width={128} />
    </S.Div>
  ) : (
    <> </>
  );
};

export default Loading;
